// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://yngwadifewcguwpetaan.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InluZ3dhZGlmZXdjZ3V3cGV0YWFuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUzNjE3ODgsImV4cCI6MjA3MDkzNzc4OH0.iqi_ZSfwvWG9Fq8tsKmTJsVUeeQXIjrXZFPsummbYFg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 2,
    },
  },
  global: {
    headers: {
      'X-Client-Info': 'captain-roca-app',
    },
  },
});